export class ReferenceSkuDiscount {
    public referenceId: number = 0;
    public skuId: number = 0;
    public discountedPrice: number | null = null;
    public savedCorrectly: boolean | null = null;

    constructor(referenceId: number, skuId: number, discountedPrice: number | null = null) {
        this.referenceId = referenceId;
        this.skuId = skuId;
        this.discountedPrice = discountedPrice;
    }
}
